import { envConfig } from '../../../env';
import { Post } from '@/service/request/server';

const baseApi = () => {
    function queryAllProject(regionType = 'MAINLAND') {
        return Post(`${envConfig.getCurrentApi()}/cotton/queryProjectDetails`, { regionType }, {
            headers: {
                SkipToken: true
            }
        });
    }

    function codeRedeem(code, projectName) {
        return Post(`${envConfig.getCurrentApi()}/plat/giftCode/redeem`, {
            code: code,
            projectName: projectName
        });
    }

    return {
        queryAllProject, codeRedeem
    };
};

export const projectApi = baseApi();